import { render, staticRenderFns } from "./StoredFiles.vue?vue&type=template&id=2406432c"
import script from "./StoredFiles.vue?vue&type=script&lang=js"
export * from "./StoredFiles.vue?vue&type=script&lang=js"
import style0 from "./StoredFiles.vue?vue&type=style&index=0&id=2406432c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports